<template>
  <v-container class="no-margins">
    <h1>{{ $t("application.company.department-title") }}</h1>

    <p>{{ $t("application.company.department-text") }}</p>
    <p>{{ $t("application.company.department-text2") }}</p>

    <!-- Form with company number input field -->
    <v-form>
      <v-text-field
        v-model="search"
        class="search-field mb-5"
        prepend-icon="$sl-search"
        single-line
        hide-details
        :label="$t('application.search-label')"
      />
    </v-form>
    <!-- Display professions as a list including machine professions if any -->
    <v-card flat>
      <v-list class="height-small">
        <v-list-item-group v-model="model" :multiple="false" :mandatory="true">
          <v-radio-group v-model="model">
            <template v-for="(item, index) in searchedItems">
              <v-list-item
                :key="'dep_' + item.id"
                @click="clickDep(item)"
                :value="item.id"
              >
                <v-list-item-content class="ml-1">
                  <v-list-item-title
                    class="body-1"
                    v-html="item.name"
                  ></v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <div class="v-list-item__radio">
                    <input type="radio" v-model="model" :value="item.id" />
                    <div class="check">
                      <div class="inside"></div>
                    </div>
                  </div>
                </v-list-item-action>
              </v-list-item>
              <v-divider :key="index"></v-divider>
            </template>
          </v-radio-group>
        </v-list-item-group>
      </v-list>
    </v-card>

    <NextButton :isDisabled="model < 0 ? true : false" class="mt-6" @click="nextStep">{{
      getNextBtnText()

    }}</NextButton>
    <!-- Go to a previous  step-->

    <BottomNav @clicked="$emit('goToStep', '-1')"></BottomNav>
  </v-container>
</template>

<script>
import API from "@/services/api.js";
import { mapActions, mapGetters } from "vuex";
import { mask } from "vue-the-mask";
import find from "lodash/find";
import { RulesMixin } from "@/components/mixins";
import BottomNav from "@/components/Application/BottomNav";
import MessageBox from "@/components/Common/MessageBox.vue";
import NextButton from "@/components/Common/NextButton";

// @group Application-Apprentice
// ApplicationCompanies component
export default {
  name: "ApplicationCompanies",

  mixins: [RulesMixin],
  props: {
    compId: {
      type: Number,
      default: -1,
    },
    nextPage: {
      type: String,
      default: '',
    }
  },
  components: {
    BottomNav,
    MessageBox,
    NextButton,
  },

  data: () => ({
    //departmentModel: null,
    dissBtn: true,
    model: -1,
    search: "",
    departments: [],
  }),

  // @vuese
  // Watch the search input in autocomplete and call the querySelections function
  // @arg The argument is a string  value representing {search: value}

  watch: {
    /**
     * @vuese
     * Used to watch the selectedApplication and fetch the company
     * @arg The argument is an integer value representing company id
     */
    selectedApplication: {
      handler: function () {
        if (this.selectedApplication && this.selectedApplication.companyId) {
          this.getDepartments();
        }
      },
      deep: true,
    },
  },
  created() {
    /**
     * @vuese
     * Used to  fetch the company once component is create if the company id exist
     * @arg The argument is an integer value representing company id
     */
    if (this.selectedApplication && this.selectedApplication.companyId) {
      this.getDepartments();
    }
  },
  computed: {
    ...mapGetters("application", ["currentStep", "selectedApplication"]),
    ...mapGetters("basic", ["hasProfessionOrientations"]),

    searchedItems() {
      var result = [];
      var filteredList = [];
      if (this.search === "") {
        result = this.departments;
      } else {
        let normalizedSearch = this.search.toLowerCase();
        result = this.departments.filter((x) =>
          x.name.toLowerCase().includes(normalizedSearch)
        );
      }
      return result;
    },
  },
  methods: {
    ...mapActions("application", ["setSelectedApplication", "updateSelectedApplication"]),

    /**
     * @vuese
     * Used fetch the departments by company id
     * @arg The argument is an integer value representing company id
     */
    getDepartments() {      
      API.listPublicDepartments(this.selectedApplication.companyId)
        .then((response) => {                                        
          if(this.selectedApplication.workplaceId && this.selectedApplication.workplaceId>0){
              this.departments = response.data.filter((r) =>
              r.workplaceIds.find((u) => u == this.selectedApplication.workplaceId));           
          }
          else {
            this.departments = response.data;           
          }
          if (
            this.selectedApplication &&
            this.selectedApplication.department &&
            this.selectedApplication.department.id
          ) {
            this.model = this.selectedApplication.department.id;
            //this.departmentModel = this.selectedApplication.department.id;
          }
        })
        .catch((error) => {
          console.log("There was an error:", error);
        });
    },
    getNextBtnText(){
      if(this.selectedApplication && this.selectedApplication.isCompanyApplication && this.selectedApplication.isCompanyApplication==true && this.nextPage!='ApplicationMessage') 
      {        
        return  this.$t("btn.instructor-next-step") 
      }
      else {
        return this.$t("tour.next") 
      } 
    },
    clickDep(item) {      
      //this.departmentModel = item.id;
      if (
        this.selectedApplication &&
        this.selectedApplication.department &&
        this.selectedApplication.department.id
      ) {
        this.model = this.selectedApplication.department.id;
      }
    },
    /**
     * @vuese
     * Used to go to the next step if form is valid and update the application with new criterias
     * @arg The argument is an integer value representing company id
     */
    nextStep() {
      if (
        this.model > 0 &&
        this.selectedApplication &&
        this.selectedApplication.companyId > 0
      ) {
        //let params = {data: { companyId: this.selectedApplication.companyId, step: this.currentStep, departmentId: this.departmentModel }}
        let params = {
          data: {
            companyId: this.selectedApplication.companyId,
            step: this.currentStep,
            departmentId: this.model,
            department: selectedDepartment,
          },
        };
        //Todo check departmentId
        let selectedDepartment = this.departments.find(
          (d) => d.id == this.model
        );

        API.updateApplication(this.selectedApplication.id, params)
          // Used to update the SelectedApplication with the found id
          .then(() => {
            this.updateSelectedApplication({
              companyId: this.selectedApplication.companyId,
              step: this.currentStep,
              departmentId: this.model,
              department: selectedDepartment,
            });

            // @arg The argument is a integer representing (move one step forward)
            this.$emit("goToStep", "+1");
          })
          .catch((error) => {
            this.$events.fire("showError", this.$t("errors.save-failure"));
          });
      } else {
        this.$events.fire("showError", this.$t("errors.save-failure"));
      }
    },
  },
};
</script>
